/**
 * Makes a contact form submission visible at both ends of the page reload.
 *
 * Shopify's contact form posts as a normal navigation, and we deliberately
 * leave it that way: `/contact` answers a background fetch with a 400, so
 * there is no dependable way to keep the customer on the page. What is left is
 * worth having anyway — acknowledge the click while the post is in flight, and
 * make the confirmation that comes back impossible to miss.
 *
 * Nothing here calls preventDefault. If this script fails to load, the form
 * behaves exactly as Shopify shipped it.
 */

const form = document.querySelector('.contact-form__form');

if (form) {
  const button = form.querySelector('.submit-button');

  // The post takes a moment, and an unresponsive button in that gap is most of
  // the reason customers doubt the message went anywhere.
  form.addEventListener('submit', () => {
    if (!form.checkValidity()) return;

    button?.setAttribute('aria-busy', 'true');
  });

  const success = form.querySelector('.contact-form__success');

  if (success) {
    requestAnimationFrame(() => {
      // The reload lands at the top of the page, and the confirmation sits
      // inside the form further down — on a phone that is well off screen, and
      // the autofocus Shopify's markup relies on does not reliably scroll
      // there. Put it in front of the customer ourselves.
      success.scrollIntoView({ block: 'center', behavior: 'smooth' });

      // Play the theme's checkmark burst. The attribute has to land after the
      // first paint, or the CSS transitions it drives have no starting state.
      if (button) button.dataset.added = 'true';
    });
  }
}
